import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 5.251a11.25 4.5 0 1 0 22.5 0 11.25 4.5 0 1 0-22.5 0"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 5.251V12c0 2.485 5.037 4.5 11.25 4.5s11.25-2.014 11.25-4.5V5.251"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 12v6.75c0 2.485 5.037 4.5 11.25 4.5s11.25-2.015 11.25-4.5V12"
    }, null, -1)
  ]));
}
const programmingComputerDatabase = { render };
export {
  programmingComputerDatabase as default,
  render
};
//# sourceMappingURL=programming-computer-database.svg.js.map
